import React from "react";
import { Box, Grid, Typography } from "@mui/material";

const testimonials = [
  {
    name: "CS SURENDRA SACHDEVA, KOLKATA",
    designation: "",
    feedback:
      "Priya Aggarwal has very ably handled the task of getting approval from the MCA for my shares which were transferred to IEPF.  She remained regularly in touch with the Registrars to the Company and concerned company officials as a result of which, all steps at the end of the company were completed at jet speed. Regular follow ups with the MCA and what was most satisfying, is giving feedback on the progress of the case to me at periodicals .  Kudos to Priya !",
  },
  {
    name: "HUZAIFA TOPIWALA, PUNE",
    designation: "",
    feedback:
      "I had a seamless experience with GetMyShares in handling the transmission of my late father's shares of SRF Ltd to my mother’s name. Their team was incredibly supportive and handled our case with great ease. The process was hassle-free, and their expertise ensured smooth documentation and timely execution. I highly recommend GetMyShares to anyone seeking professional and reliable assistance in share transfers!",
  },
];

const HomeTest: React.FC = () => {
  return (
    <Box
      sx={{
        padding: "60px 20px",
        backgroundColor: "#000000", // Black background
        textAlign: "center",
      }}
    >
      {/* Header */}
      <Typography
        variant="h4"
        sx={{
          fontWeight: "bold",
          fontFamily: "'Poppins', sans-serif",
          marginBottom: "10px",
          color: "#FFFFFF", // White text color for the header
        }}
      >
        What they say{" "}
        <Typography
          component="span"
          sx={{
            color: "#8BC34A", // Green color for "about us"
          }}
        >
          about us
        </Typography>
      </Typography>
      <Typography
        variant="subtitle1"
        sx={{
          color: "#FFFFFF", // White color for the subtitle
          fontFamily: "'Poppins', sans-serif",
          marginBottom: "40px",
        }}
      >
        TESTIMONIALS FROM OUR HAPPY CLIENTS
      </Typography>

      {/* Testimonials */}
      <Grid container spacing={4}>
        {testimonials.map((testimonial, index) => (
          <Grid item xs={12} sm={6} key={index}>
            <Box
              sx={{
                backgroundColor: "#1C1C1C", // Dark gray background for the cards
                padding: "20px",
                borderRadius: "8px",
                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.5)", // Darker shadow for contrast
                textAlign: "left",
                color: "#FFFFFF", // White text for the cards
              }}
            >
              {/* Name */}
              <Typography
                variant="h6"
                sx={{
                  fontWeight: "bold",
                  fontFamily: "'Poppins', sans-serif",
                  marginBottom: "8px",
                }}
              >
                {testimonial.name}
              </Typography>
              {/* Designation */}
              <Typography
                variant="body1"
                sx={{
                  color: "#8BC34A", // Green color
                  fontWeight: "bold",
                  fontFamily: "'Poppins', sans-serif",
                  marginBottom: "12px",
                }}
              >
                {testimonial.designation}
              </Typography>
              {/* Feedback */}
              <Typography
                variant="body2"
                sx={{
                  color: "#FFFFFF", // White text for feedback
                  fontFamily: "'Poppins', sans-serif",
                  fontStyle: "italic",
                }}
              >
                "{testimonial.feedback}"
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default HomeTest;